import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en_US.json';
import de from './locales/de_DE.json';

let currentLanguage = "de_DE";
if(window.Liferay && window.Liferay.ThemeDisplay && window.Liferay.ThemeDisplay.getLanguageId()) {
    currentLanguage = window.Liferay.ThemeDisplay.getLanguageId();
}

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        de: { translation: de },
    },
    lng: currentLanguage,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
